<form [formGroup]="clientForm" (ngSubmit)="onSubmit()" #clientFormRef="ngForm">
	<div class="modal-body">
		<!-- <div class="form-group position-relative mx-auto">
            <div class="row">
                <label for="" class="col-2 label-control">Identificador</label>
                <div class="col-9">
                    <input type="text" name="identifier" id="identifier" formControlName="identifier" class="form-control" [attr.disabled]="(clientToEdit ||editMode)">
                    <div *ngIf="clientFormRef.submitted &&( clientForm.get('identifier').invalid || clientForm.get('identifier').dirty )" class="invalid-feedback">
                        <div *ngIf="clientForm.get('identifier').errors?.required">Campo requerido</div>
                        <div *ngIf="clientForm.get('identifier').errors?.maxLength">Largo de idenficador debe ser menor a {{this.largoIdentificador}}</div>
                    </div>
                </div>
               
            </div>
        </div> -->
		<div class="form-group position-relative mx-auto">
			<div class="row">
				<label for="" class="col-2 label-control">Identificador</label>
				<div class="col-9">
					<input type="text" name="codigoInterno" id="codigoInterno" formControlName="codigoInterno" maxlength="15" class="form-control" [attr.disabled]="!editMode ? editMode : null" />
					<div *ngIf="clientFormRef.submitted && (clientForm.get('razonSocial').invalid || clientForm.get('codigoInterno').dirty)" class="invalid-feedback">
						<div *ngIf="clientForm.get('codigoInterno').errors?.required">Campo requerido</div>
					</div>
				</div>
			</div>
		</div>
		<div class="form-group position-relative mx-auto">
			<div class="row">
				<label for="" class="col-2 label-control">Razón Social</label>
				<div class="col-9">
					<input type="text" name="razonSocial" id="razonSocial" formControlName="razonSocial" class="form-control" [attr.disabled]="!editMode ? editMode : null" />
					<div *ngIf="clientFormRef.submitted && (clientForm.get('razonSocial').invalid || clientForm.get('razonSocial').dirty)" class="invalid-feedback">
						<div *ngIf="clientForm.get('razonSocial').errors?.required">Campo requerido</div>
					</div>
				</div>
			</div>
		</div>
		<div class="form-group position-relative mx-auto">
			<div class="row">
				<label for="" class="col-2 label-control">Nombre de Fantasía</label>
				<div class="col-9">
					<input type="text" name="nombreFantasia" id="nombreFantasia" formControlName="nombreFantasia" class="form-control" [attr.disabled]="!editMode ? editMode : null" />
					<div *ngIf="clientFormRef.submitted && (clientForm.get('nombreFantasia').invalid || clientForm.get('nombreFantasia').dirty)" class="invalid-feedback">
						<div *ngIf="clientForm.get('nombreFantasia').errors?.required">Campo requerido</div>
					</div>
				</div>
			</div>
		</div>
		<div class="form-group position-relative mx-auto">
			<div class="row">
				<label for="" class="col-2 label-control">Giro</label>
				<div class="col-9">
					<input type="text" name="giro" id="giro" formControlName="giro" class="form-control" [attr.disabled]="!editMode ? editMode : null" />
					<div *ngIf="clientFormRef.submitted && (clientForm.get('giro').invalid || clientForm.get('giro').dirty)" class="invalid-feedback">
						<div *ngIf="clientForm.get('giro').errors?.required">Campo requerido</div>
					</div>
				</div>
			</div>
		</div>
		<div class="form-group position-relative mx-auto">
			<div class="row">
				<label for="" class="col-2 label-control">Dirección / Calle</label>
				<div class="col-9">
					<input type="text" name="direccionCalle" id="direccionCalle" formControlName="direccionCalle" class="form-control" [attr.disabled]="!editMode ? editMode : null" />
					<div *ngIf="clientFormRef.submitted && (clientForm.get('direccionCalle').invalid || clientForm.get('direccionCalle').dirty)" class="invalid-feedback">
						<div *ngIf="clientForm.get('direccionCalle').errors?.required">Campo requerido</div>
					</div>
				</div>
			</div>
		</div>
		<div class="form-group position-relative mx-auto">
			<div class="row">
				<label for="" class="col-2 label-control">Dirección / Numero</label>
				<div class="col-9">
					<input type="text" name="direccionNumero" id="direccionNumero" maxlength="10" formControlName="direccionNumero" class="form-control" [attr.disabled]="!editMode ? editMode : null" />
					<div *ngIf="clientFormRef.submitted && (clientForm.get('direccionNumero').invalid || clientForm.get('direccionNumero').dirty)" class="invalid-feedback">
						<div *ngIf="clientForm.get('direccionNumero').errors?.required">Campo requerido</div>
					</div>
				</div>
			</div>
		</div>
		<div class="form-group position-relative mx-auto">
			<div class="row">
				<label for="" class="col-2 label-control">Dirección / Adicional o referencia</label>
				<div class="col-9">
					<input type="text" name="direccionLineaAdicional" id="direccionLineaAdicional" formControlName="direccionLineaAdicional" class="form-control" [attr.disabled]="!editMode ? editMode : null" />
					<!-- <div *ngIf="clientFormRef.submitted &&( clientForm.get('direccionLineaAdicional').invalid ||  clientForm.get('direccionLineaAdicional').dirty)" class="invalid-feedback">
                        <div *ngIf="clientForm.get('direccionLineaAdicional').errors?.required">Campo requerido</div>
                    </div> -->
				</div>
			</div>
		</div>
		<div class="form-group position-relative mx-auto">
			<div class="row">
				<label for="" class="col-2 label-control">Dirección / Estado-Region</label>
				<div class="col-9">
					<input type="text" name="direccionEstadoRegion" id="direccionEstadoRegion" formControlName="direccionEstadoRegion" class="form-control" [attr.disabled]="!editMode ? editMode : null" />
					<div *ngIf="clientFormRef.submitted && (clientForm.get('direccionEstadoRegion').invalid || clientForm.get('direccionEstadoRegion').dirty)" class="invalid-feedback">
						<div *ngIf="clientForm.get('direccionEstadoRegion').errors?.required">Campo requerido</div>
					</div>
				</div>
			</div>
		</div>
		<div class="form-group position-relative mx-auto">
			<div class="row">
				<label for="" class="col-2 label-control">Ciudad</label>
				<div class="col-9">
					<input type="text" name="ciudad" id="ciudad" formControlName="ciudad" class="form-control" [attr.disabled]="!editMode ? editMode : null" />
					<div *ngIf="clientFormRef.submitted && (clientForm.get('ciudad').invalid || clientForm.get('ciudad').dirty)" class="invalid-feedback">
						<div *ngIf="clientForm.get('ciudad').errors?.required">Campo requerido</div>
					</div>
				</div>
			</div>
		</div>
		<div class="form-group position-relative mx-auto">
			<div class="row">
				<label for="" class="col-2 label-control">Correo Electrónico</label>
				<div class="col-9">
					<input type="text" name="correo" id="correo" formControlName="correo" class="form-control" [attr.disabled]="!editMode ? editMode : null" />
					<div *ngIf="clientFormRef.submitted && (clientForm.get('correo').invalid || clientForm.get('correo').dirty)" class="invalid-feedback">
						<div *ngIf="clientForm.get('correo').errors?.required">Campo requerido</div>
						<div *ngIf="clientForm.get('correo').hasError('wrongEmail')">Correo inválido</div>
					</div>
				</div>
			</div>
		</div>

		<!-- <div class="form-group position-relative mx-auto">
            <div class="row">
                <label for="" class="col-2 label-control">Teléfono</label>
                <div class="col-9">
                    <input type="text" name="telefono" id="telefono" formControlName="telefono" class="form-control" [attr.disabled]="!editMode?editMode:null">
                    <div *ngIf="clientFormRef.submitted &&( clientForm.get('telefono').invalid ||  clientForm.get('telefono').dirty)" class="invalid-feedback">
                        <div *ngIf="clientForm.get('telefono').errors?.required">Campo requerido</div>
                    </div>
                </div>
            </div>
        </div> -->
		<div class="form-group position-relative mx-auto">
			<div class="row">
                            <label for="" class="col-2 label-control">País</label>
				<div class="col-9">
					<!-- <input type="text" name="pais" id="pais" formControlName="pais" class="form-control" [attr.disabled]="!editMode?editMode:null"> -->

					<ng-select formControlName="pais" [items]="paisesSource" [clearable]="false" bindLabel="nombre"></ng-select>
					<div *ngIf="clientFormRef.submitted && (clientForm.get('pais').invalid || clientForm.get('pais').dirty)" class="invalid-feedback">
						<div *ngIf="clientForm.get('pais').errors?.required">Campo requerido</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button type="submit" id="add-contact-item" class="btn btn-success add-contact-item" *ngIf="editMode || editMode === null">
			<i class="la la-paper-plane-o d-lg-none"></i>
			<span class="d-none d-lg-block">{{ clientToEdit ? "Guardar" : "Generar" }}</span>
		</button>
		<button type="button" class="btn btn-secondary ml-3" (click)="sendCloseRequest()">
			<span class="d-none d-lg-block">Cerrar</span>
		</button>
	</div>
</form>
